import * as React from "react";
import faqData from "../data/faqData.json";
import * as faq from '../styles/faq.module.scss';
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

export const Faq = ({data={ faqData }}) => {

  return (
    <section className={faq.questions}>
      <div className="container">
        <div className={faq.questions__title}>Часто задаваемые вопросы:</div>
        <div className={faq.questions_row}>
          <div className={faq.questions_col}>
            {faqData.map((elem, index) => (
              <div className={faq.questions_col_item} key={index}>
                <div className={faq.questions_col_item_header}>{elem.theme}</div>
                {elem.questions.map((elem, index) => (
                  <Accordion
                    key={index}
                    disableGutters={true}
                    className={faq.questions_col_item_name}
                    sx={{
                      boxShadow: "unset",
                      "&::before": {
                        display: "none"
                      },
                      "&.Mui-expanded": {
                        margin: 0,
                        "&::after": {
                          transform: "rotate(90deg)"
                        },
                      },
                    }}>
                    <AccordionSummary
                      sx={{
                        ".MuiAccordionSummary-content": {
                          margin: "20px 0"
                        },
                      }}>
                      {elem.question}
                    </AccordionSummary>
                    <AccordionDetails
                      sx={{
                        fontSize: "15px",
                        fontWeight: 400
                      }}>
                      {elem.answer}
                    </AccordionDetails>
                  </Accordion>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
